export const openNotificationAlert = (data) => {
  return {
    type: "OPEN_NOTIFICATION_ALERT",
    data,
  };
};

export const closeNotificationAlert = () => ({
  type: "CLOSE_NOTIFICATION_ALERT",
});
